import { render, staticRenderFns } from "./OfferDetailStakeholders.vue?vue&type=template&id=29613a35"
import script from "./OfferDetailStakeholders.vue?vue&type=script&lang=js"
export * from "./OfferDetailStakeholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports